import ReactGA from "react-ga4";
const { VITE_CI, VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID } = import.meta.env;

const checkConsentAndInitializeGA = () => {
  const cookieYesConsent = window.getCkyConsent ? window.getCkyConsent() : null;
  const consentViaCookieYes =
    cookieYesConsent && cookieYesConsent.categories.analytics;
  const noCmp = !window.getCkyConsent;

  if (VITE_CI || !(noCmp || consentViaCookieYes)) {
    return;
  }

  if (VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID) {
    ReactGA.initialize(VITE_GOOGLE_ANALYTICS_MEASUREMENT_ID);
  }
};

checkConsentAndInitializeGA();

export { ReactGA };
